module.exports = {"message":"hello i18n !!","cutLocalImage":"Recadrer des photos locales","choseImage":"Sélectionner une image","showAfterProcess":"Afficher ici après le recadrage","downloadNewImage":"Télécharger l'image","submit":"déterminer","reset":"Réinitialiser","trunLeft":"Tourner à gauche","trunRight":"Tournez à droite","cancel":"annuler","mainTitle":"Recadrer et faire pivoter des images en ligne","txtDescription":"Utilisez cet outil pour recadrer ou faire pivoter une image"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.json
// module id = FiWC
// module chunks = 1